import React from 'react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = 70;
      const targetPosition = section.offsetTop - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleWhatsAppClick = () => {
    const whatsappURL = 'https://api.whatsapp.com/send?phone=5575999481498&text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20Paradise%20Formaturas.';
    window.open(whatsappURL, '_blank');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/paradise-logo.svg" alt="Paradise Formaturas Logo" className="footer-logo" />
            <p>Transformando sonhos em realidade através de experiências únicas e memoráveis.</p>
          </div>
          
          <div className="footer-section">
            <h4>Links Rápidos</h4>
            <ul className="footer-links">
              <li><a href="#inicio" onClick={() => scrollToTop()}>Início</a></li>
              <li><a href="#quem-somos" onClick={() => scrollToSection('quem-somos')}>Quem Somos</a></li>
              <li><a href="#portfolio" onClick={() => scrollToSection('portfolio')}>Portfólio</a></li>
              <li><a href="#feedback" onClick={() => scrollToSection('feedback')}>Feedback</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contato</h4>
            <div className="contact-info">
              <p><i className="fas fa-phone"></i> (75) 9 9948-1498</p>
              <p><i className="fas fa-map-marker-alt"></i> Rua Dr. João Dantas 289, 1º e 2º andar, Bairro Santa Terezinha, próximo da SELFIT, Alagoinhas-BA.</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Redes Sociais</h4>
            <div className="social-links">
              <a href="https://www.instagram.com/paradiseformaturas/" target="_blank" rel="noopener">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.youtube.com/channel/UCbSYYiOkL3ZAuy-lzJKnsow" target="_blank" rel="noopener">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#" onClick={handleWhatsAppClick}>
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
            <a href="http://www.eFormei.com.br/sistema" className="area-formando-btn footer-btn" target="_blank" rel="noopener">
              <i className="fas fa-graduation-cap"></i>
              ÁREA DO FORMANDO
            </a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Paradise Formaturas. Todos os direitos reservados. v1.9</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;